import React, { useRef } from "react";
import { getMinEventDateValue, getTodayDateValue, isDateBeforeMinEventDate } from "./dateUtils";

export default function Step1Form({
  form,
  handleChange,
  handleSubmit,
  loading,
  price,
  proceedToStep2,
  formatCurrency,
  locationRef,
  t,
}) {
  const eventDateRef = useRef(null);

  const hours = Array.from({ length: 25 }, (_, i) =>
    `${String(i).padStart(2, "0")}:00`
  );
  const minEventDateValue = getMinEventDateValue();
  const todayDateValue = getTodayDateValue();

  const openDatePickerFromToday = () => {
    const input = eventDateRef.current;
    if (!input || form.start_date) return;

    input.value = todayDateValue;
    window.setTimeout(() => {
      if (!form.start_date && input.value === todayDateValue) {
        input.value = "";
      }
    }, 250);
  };

  const handleDateChange = (e) => {
    if (isDateBeforeMinEventDate(e.target.value)) {
      e.target.value = "";
      handleChange({ target: { name: "start_date", value: "" } });
      return;
    }

    handleChange(e);
  };

  const getValidEndHours = () => {
    const startHour = parseInt(form.start_hour.split(":")[0], 10);
    const min = startHour + 1;
    const max = Math.min(startHour + 9, 24);
    return hours.slice(min, max + 1);
  };

  const indemnity = Number(form.amount || 0) * 0.7;

  return (
    <form onSubmit={handleSubmit} className="configurator-form fade-in">
      {/* DATA + LOCATION */}
      <div className="row two-cols">
        <div className="col">
          <label>🗓️ {t.eventDate}</label>
          <input
            type="date"
            name="start_date"
            ref={eventDateRef}
            value={form.start_date}
            onChange={handleDateChange}
            onFocus={openDatePickerFromToday}
            onPointerDown={openDatePickerFromToday}
            min={minEventDateValue}
            required
          />
        </div>

        <div className="col">
          <label>🏰  {t.location}</label>
          <input
            type="text"
            name="location"
            ref={locationRef}
            placeholder={t.locationPlaceholder}
            value={form.location}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </div>
      </div>

      {/* IMPORTO ASSICURATO */}
      <div className="row">
        <label>💰 {t.budget}</label>
        <input
          type="number"
          name="amount"
          value={form.amount}
          onChange={handleChange}
          placeholder={t.amountPlaceholder}
          min="500"
          step="100"
          required
        />
        <div className="indemnity-hint fade-in">
          {t.indemnity} (70%): <strong>{formatCurrency(indemnity)}</strong>
        </div>
      </div>

      {/* SOGLIA PIOGGIA */}
      <div className="row">
        <label>🌧️ {t.rainThreshold}</label>
        <div className="rain-selector">
          {[
            { value: "2mm", icon: "☁️", title: t.light, desc: t.lightDesc },
            { value: "5mm", icon: "🌧️", title: t.moderate, desc: t.moderateDesc },
            { value: "10mm", icon: "⛈️", title: t.heavy, desc: t.heavyDesc },
          ].map((opt) => (
            <label
              key={opt.value}
              className={`rain-option ${form.amount_rain === opt.value ? "active" : ""}`}
            >
              <input
                type="radio"
                name="amount_rain"
                value={opt.value}
                checked={form.amount_rain === opt.value}
                onChange={handleChange}
              />
              <div className="rain-content">
                <div className="rain-icon">{opt.icon}</div>
                <div className="rain-text">
                  <strong>{opt.title} </strong>
                  <small>({opt.value})</small><br></br>
                </div>
              </div>
            </label>
          ))}
        </div>
      </div>

      {/* ORARI */}
      <div className="row two-cols">
        <div className="col">
          <label>🕓 {t.coverageStart}</label>
          <select name="start_hour" value={form.start_hour} onChange={handleChange}>
            {hours
              .filter((_, i) => i < 24) 
              .map((h) => (
                <option key={h} value={h}>
                  {h}
                </option>
              ))}
          </select>

        </div>

        <div className="col">
          <label>⏰ {t.coverageEnd}</label>
          <select name="end_hour" value={form.end_hour} onChange={handleChange}>
            {getValidEndHours().map((h) => (
              <option key={h} value={h}>
                {h}
              </option>
            ))}
          </select>
        </div>
      </div>
        <div className="col">⚠️ {t.maxHours}</div>

      {/* SUBMIT */}
      <button type="submit" className="buttonConfig" disabled={loading}>
        {loading ? t.calculateLoading : t.calculate}
      </button>

      {/* RISULTATO */}
      {price != null && (
        <div className="result fade-in">
          <div>
            💰 {t.estimatedPremium}: <strong>{formatCurrency(price)}</strong>
          </div>
          <button
            type="button"
            className="next"
            onClick={proceedToStep2}
            style={{ marginTop: 12 }}
          >
            {t.proceed}
          </button>
        </div>
      )}
    </form>
  );
}
